import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Layout from '../../components/LayoutNew'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import { SECTION_ONE } from '../../constants/targetedDeliverySolution'
import TitleWrapper from '../../components/TitleWrapper'
import ProductSection2 from '../../containers/ProductSection2'
import Img from 'gatsby-image'

import './targetedDeliverySolution.scss'

const prefix = 'targeted-delivery'

const Section1 = () => {
  return (
    <div className="section-1">
      {SECTION_ONE.map((section, index) => (
        <div className="section-item" key={index}>
          <TitleWrapper
            titleClassName={`${prefix}-number`}
            title={`0${index + 1}`}
            withSeparator={false}
          />
          <TitleWrapper
            titleClassName={`${prefix}-title`}
            title={section.title}
            withSeparator={false}
          />
          <TitleWrapper
            titleClassName={`${prefix}-sub-title`}
            title={section.subTitle}
            withSeparator={false}
          />
        </div>
      ))}
    </div>
  )
}

const TargetedDeliverySolutionPage = () => {
  const pageColor = '#E52B58'
  const { group0, group1 } = useStaticQuery(graphql`
    query {
      group0: file(
        relativePath: {
          eq: "systemProduct/targetedDeliverySolution/Group0.png"
        }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      group1: file(
        relativePath: {
          eq: "systemProduct/targetedDeliverySolution/Group1.png"
        }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout
      className="targeted-delivery-solution-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="精准投放解决方案"
        subTitleArray={[
          '品牌重塑，用全新的品牌形象去占领用户心智；全域渠道平台营销推广路径，匹配达人种草，平台流量服务等实现多触点投放策略，定向从大流量池获客；帮助客户建立私域流量池，用口碑效应培植粘性客群，实现多次复购',
        ]}
      />
      <Section1 />
      <ProductSection2
        className="section-2"
        title="内容驱动流量，持续生产可复刻的爆款内容"
        subTitle="定制内容打法实现超低获客成本"
        image={
          <div style={{ width: '522px' }}>
            <Img fluid={group0.childImageSharp.fluid} alt="精准投放解决方案" />
          </div>
        }
      />
      <ProductSection2
        className="section-3"
        background={pageColor}
        title="连登TikTok话题榜，入选平台优秀案例"
        type="row-reverse"
        subTitle="引流落地页，对用户行为深度追踪"
        image={
          <div style={{ width: '522px' }}>
            <Img fluid={group1.childImageSharp.fluid} alt="精准投放解决方案" />
          </div>
        }
      />
      <HomeSection3 />
    </Layout>
  )
}

export default TargetedDeliverySolutionPage
